import { SUBJECT_CODES } from "@repo/shared";
import { match, P } from "ts-pattern";

import English from "~/assets/subjects/english.webp";
import Math from "~/assets/subjects/math.webp";
import Polish from "~/assets/subjects/polish.webp";

export const getSubjectImage = (subjectCode?: string | null) => {
  if (!subjectCode) {
    return undefined;
  }

  return match(subjectCode)
    .with(
      P.when((code) => code === SUBJECT_CODES.POLISH),
      () => Polish,
    )
    .with(
      P.when((code) => code === SUBJECT_CODES.ENGLISH),
      () => English,
    )
    .with(
      P.when((code) => code === SUBJECT_CODES.MATH),
      () => Math,
    )
    .otherwise(() => undefined);
};
